<template>
  <div class="d-flex align-items-center gap-2 mt-1">
    <div>
      {{ $t("js.backend.live.close_in") }}
    </div>
    <div class="input-group flex-nowrap">
      <input
        type="number"
        min="0"
        max="59"
        :value="customCloseMins"
        @change="($event: Event) => customCloseMins = addLeadingZero(Number(($event.target as HTMLInputElement).value))"
        id="customCloseMins"
        class="form-control minutes-control"
        :aria-label="$t('js.backend.live.aria_label.minutes', { n: customCloseMins })"
      />
      <span class="input-group-text separator">:</span>
      <input
        type="number"
        min="0"
        max="59"
        :value="customCloseSecs"
        @change="($event: Event) => customCloseSecs = addLeadingZero(Number(($event.target as HTMLInputElement).value))"
        id="customCloseSecs"
        class="form-control seconds-control"
        :aria-label="$t('js.backend.live.aria_label.seconds', { n: customCloseSecs })"
      />
    </div>
    <AsyncButton
      class="btn btn-dark cursor-pointer"
      @click="closeBallot(customTimer)"
      v-text="$t('js.backend.live.apply')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AsyncButton from "@/components/shared/AsyncButton.vue";

export default defineComponent({
  name: "CustomCloseTimer",
  components: { AsyncButton },
  data() {
    return {
      customCloseMins: "05",
      customCloseSecs: "00",
    }
  },
  computed: {
    customTimer() {
      return (parseInt(this.customCloseMins) * 60) + parseInt(this.customCloseSecs);
    },
  },
  methods: {
    addLeadingZero(number: number) {
      if (number < 10) return `0${number}`;
      if (number > 59) return `59`;
      else return `${number}`;
    },
    closeBallot(value: number) {
      this.$emit("setCustomTimer", value);
    },
  },
});
</script>

<style lang="scss" scoped>
.minutes-control {
  border-right: none !important;
  width: fit-content;
  padding: 6px 0 6px 12px !important;
}

.separator {
  padding-left: 0 !important;
  padding-right: 0 !important;
  background-color: transparent !important;
}

.seconds-control {
  border-left: none !important;
  width: fit-content;
  padding: 6px 6px 6px 12px !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>
